module.exports = __webpack_public_path__ + "media/images/turtle_head-4a5d2cbfc4983ace696fa20194402b71.png";